
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PadoNPCComponent from '@/components/ParceDomine/PadoNPCComponent.vue';
import PadoMapComponent from '@/components/ParceDomine/PadoMapComponent.vue';
import PadoMJTurnOrderComponent from '@/components/ParceDomine/PadoMJTurnOrderComponent.vue';
import AzrNPCComponent from "@/components/Azuria/AzrNPCComponent.vue";
import {MJMixin} from '@/mixins/MJMixin';

@Component({
    components: {AzrNPCComponent, PadoMJTurnOrderComponent, PadoMapComponent, PadoNPCComponent},
})

export default class AzrMJComponent extends mixins(MJMixin) {
    created(): void {
        this.npcs = Array(Object.values(this.game.characters).filter(char => {
            return char.isNPC;
        }).length);
        for (let i = 0; i < this.npcs.length; i++) {
            this.npcs[i] = false;
        }
    }
}
